import { render } from "./AssessmentDiagnosisNew.vue?vue&type=template&id=184e83e8&scoped=true"
import script from "./AssessmentDiagnosisNew.vue?vue&type=script&lang=js"
export * from "./AssessmentDiagnosisNew.vue?vue&type=script&lang=js"

import "./AssessmentDiagnosisNew.vue?vue&type=style&index=0&id=184e83e8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\PamelaOsunza\\OneDrive - dermapp.com\\Escritorio\\dermapp\\dermapp-pacientes-staging\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-184e83e8"]])

export default __exports__